import React from "react";
import Card from "react-bootstrap/Card";
import { IoIosArrowForward } from "react-icons/io";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "Left" }}>
            Hello, I am <span className="purple">Tanish Kumar Gaur </span>
            from  <span className="purple">Indore,India.</span>
            <br /><br />I am a current graduate student pursuing  b-tech in Computer Science from the <span className="purple">Acropolis Institute of Research And Technology.</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do
          </p>
          <ul>
            <li className="about-activity">
              <IoIosArrowForward /> Reading
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Playing Football
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Traveling
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Playing Games
            </li>
            {/* <li className="about-activity">
              <IoIosArrowForward /> Software Projects
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Learning Languages
            </li> */}
          </ul>

          <p style={{ color: "#2D82B7", textAlign: "left" }}>
            "Trying is much better than regretting” {" "}
          </p>
          <footer className="blockquote-footer">Tanish Kumar Gaur</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
